import { v4 as uuid } from 'uuid';
import { new_ErrorAlert } from '../export_spwk/ExportManager';
import { Lang, SpwkUtil } from './SpwkUtil';
import { SpwkUtilV3 } from './SpwkUtilV3';
import { UniInput } from './UniInput';
import { UniQuestion } from './UniQuestion';

export class UniOption {


  static END_POINT = "uni_option";

  //#region  --- Columns ---
  serno = 0;
  guid;//= uuid();

  sort_no = 1000;

  question_guid = "";

  /** 是否為新版合併專用的(0原稿不存在、1合併用的版本)
 * - 通用Form裡面的 既往病史 與 自覺症狀 固定的題目分類
 * - 不在職安屬Word但是拆分出來的選項
 */
  v3_mode = 0;

  /** 新版拆分用的的代碼 相當於 v3_question_code */
  v3_group = "";

  /** 新版拆分用的的代碼 相當於 v3_option_code */
  v3_codeXXX = "";
  getV3Code() {
    return this.option_code;
  }

  setV3Code(code: string) {
    this.option_code = code;
  }

  /** option 的 variant 文字樣式 */
  variant = "";

  /** 此項目是否被拆分了，拆分後可能就不用再顯示 */
  is_split_parent = 0;

  /** 如果此項目是由其他項目拆分來的，指出是從哪裡拆的，否則空白 */
  split_from_option_guid = "";

  option_code = "";
  option_title = "";

  /** HIS答案對照代碼(結果) */
  o_his_code = "";

  /** 申報 選項代碼 */
  o_gov_code = "";

  /** 選項標題(英語) */
  title_eng = "";

  /** 選項標題(印尼) */
  title_ind = "";

  /** 選項標題(泰國) */
  title_tha = "";

  /** 選項標題(菲律賓) */
  title_tgl = "";

  /** 選項標題(越南) */
  title_vie = "";

  /** 連動觸發項目 */
  triggers = "";

  /** 判斷性別 */
  gender_filter = "";

  /** 是否隱藏 hidden visible... */
  visibility = "";

  //#region 


  //#region --- View ---
  form_guid: string | null = null;

  question_chapter: string | null = null;
  question_code: string | null = null;
  question_kind: string | null = null;

  /** HIS章節代碼(類別) */
  ch_his_code = "";

  /** HIS題目代碼(項目) */
  q_his_code = "";

  //#endregion

  /** 此選項的 rhf_name */
  // get_Option_RhfName(): string {
  //   return SpwkUtil.get_Option_RhfName(this.question_chapter ?? "?????", this.question_code ?? "?????", this.option_code);
  // }

  // /** 選項內內涵Input 的 rhf_name */
  // get_Input_RhfName(input_key: string): string {
  //   return SpwkUtil.get_Input_RhfName(this.question_chapter ?? "?????", this.question_code ?? "?????", this.option_code, input_key);
  //   // return chapter + "." + this.question_code + "●" + this.option_code + "●txt_" + input_key;
  // }


  get_Option_RhfName(): string {
    if (SpwkUtilV3.IsEnabled) {
      return SpwkUtilV3.get_Option_RhfName_V3(this);
    } else {
      return SpwkUtil.get_Option_RhfName(this.question_chapter ?? "?????", this.question_code ?? "?????", this.option_code);
    }
  }

  /** 選項內內涵Input 的 rhf_name */
  get_Input_RhfName(input_key: string): string {
    if (SpwkUtilV3.IsEnabled) {
      return SpwkUtilV3.get_Input_RhfName_V3(this, input_key);
    } else {
      throw new_ErrorAlert("468461 不再支援 舊版解碼 !!!");
    }

  }

  constructor() {
    this.guid = uuid();
  }

  //#region --- 手動填入 ---
  OwnerQuestion?: UniQuestion;
  Inputs?: UniInput[];
  //#endregion

  /** 取得主要語言 */
  getTitleLangA(lang: Lang) {
    return SpwkUtil.__getOptionTitleByLang(this, lang);
  }

  /** 取得次要語言 */
  getTitleLangB(lang: Lang) {
    return SpwkUtil.__getOptionTitleByLang(this, lang);
  }

  Is多選_無() {
    return this.Is無_或_以上皆無();
  }


  /**
   * 判斷此選項是否有黏 inputs (注意! 這裡假定所有語言都有相同的 inputs)
   */
  HasInputs() {
    return this.option_title.includes("{_") && this.option_title.includes("_}");
  }


  Is其他(): boolean {
    let x = this;
    let code = x.getV3Code();
    return code !== "其他_無" && (code.startsWith("其他_") || code.endsWith("_其他") || code === "其他")
  }

  Is無_或_以上皆無(): boolean {
    let x = this;
    let code = x.getV3Code();
    return (code === "其他_無" || code.endsWith("_無") || code === "無" || code.endsWith("_以上皆無") || code === "以上皆無");
  }



}


/**
 * 黏在 Option 上的 Input 相關屬性定義
 */
export class InputToken {
  OwnerOption?: UniOption;

  InputAttr?: UniInput;

  input_code: string;

  // kind?: string;

  constructor(owner_option: UniOption, input_code: string) {
    this.OwnerOption = owner_option;

    this.InputAttr = owner_option.Inputs?.find(x => x.input_code === input_code && x.option_guid === owner_option.guid);

    this.input_code = input_code;
  }

}
